/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.controller('StatsCtrl', function($scope, Stats, ErrorThrower, modules_url) {
    $scope.modules_url      = modules_url;
    const errorManager            = new ErrorThrower;
    $scope.total_views      = 0;
    $scope.views_in_percent = 0;
    $scope.selected_course  = null;

    // On enlève les stats quand on change de module
    $scope.$watch(() => $scope.selected_module
    , function() {
        $scope.total_views      = 0;
        $scope.views_in_percent = 0;
        return $scope.selected_course  = null;
    }
    , true);

    const match_file = function(course_name, file_path) {
        const regex = new RegExp(`.*\/${course_name}\/.*`, 'i');
        return file_path.match(regex);
    };

    return $scope.selectCourse = function(course) {
        $scope.selected_course = course;
        return Stats
        .getStatsViews({
            activity_id: $scope.selected_course.id,
            session_id:  $scope.selected_module.id}).$promise
        .then(function(result) {
            $scope.students_total = result.students_total;
            if (0 < result.single_file_views.length) {
                $scope.total_views = ((() => {
                    const result1 = [];
                    
                    for (let file of Array.from(result.single_file_views)) {                         if (match_file(course.name, file.path)) {
                            result1.push(file.views);
                        }
                    }
                
                    return result1;
                })());
                $scope.total_views      = $scope.total_views[0];
                return $scope.views_in_percent = ($scope.total_views / $scope.students_total) * 100;
            } else {
                $scope.total_views      = 0;
                return $scope.views_in_percent = 0;
            }}).catch(api_error => errorManager.minor(api_error.statusText));
    };
});
